<template lang="pug">
.v-confirm-modal.confirm-modal(v-if="data" )
	template(v-if="data.variant === 'vip5'")
		.vip5-confirm
			.vip5-confirm__header
				span.vip5-confirm__header-icon(aria-hidden="true") i
				span.vip5-confirm__eyebrow {{ data.eyebrow }}
			h2.vip5-confirm__title(v-if="data.title") {{ data.title }}
			p.vip5-confirm__lead(v-if="data.lead") {{ data.lead }}
			.vip5-confirm__availability(v-if="data.date")
				span.vip5-confirm__availability-label(v-if="data.dateLabel") {{ data.dateLabel }}
				time.vip5-confirm__date {{ data.date }}
			p.vip5-confirm__note(v-if="data.note") {{ data.note }}
	template(v-else)
		.confirm-modal__title(v-if="data.title" ) {{ data.title }}
		.confirm-modal__note(v-if="data.note" ) {{ data.note }}
	.confirm-modal__buttons
		button.confirm-modal__button(v-for="(button, index) in data.buttons"
			:key="index"
			:class="button.className"
			@click="handleEvent(button.event)")
			| {{ button?.text }}
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import controller from '../scripts/controller/controller.js';
export default {
	mixins: [
		sourceMixin,
	],

	emits: ['confirm'],

	data() {
		return {
			data: null
		};
	},

	methods: {
		dataSet(data) {
			this.data = data;
		},

		handleEvent(event) {
			switch (event) {
				case 'reject': {
					controller.closeModal();
					break;
				}
				case 'confirm': {
					if (this.data.redirectOnConfirm) {
						window.location.replace(this.data.redirectOnConfirm);
						break;
					}
					controller.closeModal();
					this.$emit('confirm');
					break;
				}
			}
		}
	}
};
</script>
